// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/**
 * Checkbox Mixins.
 */
@keyframes check {
  0% {
    height: 0;
    left: 0;
    top: 8px;
    width: 0;
  }
  50% {
    height: 0;
    left: 0;
    top: 8px;
    width: 4px;
  }
  100% {
    height: 10px;
    left: 4px;
    top: 0;
    width: 4px;
  }
}
@keyframes checkindeterminate {
  0% {
    width: 0;
  }
  100% {
    width: 10px;
  }
}
.validation-message {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: flex;
  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);
  margin-top: var(--ids-space-2xs);
  max-width: var(--ids-input-width-full);
}
.validation-message.has-custom-icon {
  color: var(--ids-icon-color-default);
}
.validation-message.disabled {
  color: var(--ids-input-color-text-disabled);
}
.validation-message .ids-icon {
  margin-inline-end: var(--ids-space-2xs);
}
.validation-message.alert {
  color: var(--ids-color-caution-default);
}
.validation-message.alert.disabled {
  color: var(--ids-color-yellow-30);
}
.validation-message.warning {
  color: var(--ids-color-warning-default);
}
.validation-message.warning.disabled {
  color: var(--ids-color-orange-30);
}
.validation-message.error {
  color: var(--ids-color-error-default);
}
.validation-message.error.disabled {
  color: var(--ids-color-red-30);
}
.validation-message.info {
  color: var(--ids-color-info-default);
}
.validation-message.info.disabled {
  color: var(--ids-color-blue-30);
}
.validation-message.success {
  color: var(--ids-color-success-default);
}
.validation-message.success.disabled {
  color: var(--ids-color-green-30);
}
.validation-message[hidden] {
  display: none;
}

:host(.justify-center) .ids-checkbox .checkmark,
:host(.justify-center) .ids-checkbox:not([color]) input[type=checkbox] ~ .checkmark {
  top: calc(50% - 8px);
}

:host([no-margin]) .ids-checkbox {
  margin: var(--ids-space-none);
}

.ids-checkbox {
  margin-bottom: var(--ids-space-xs);
  margin-top: var(--ids-checkbox-margin-top);
}
.ids-checkbox label {
  cursor: var(--ids-cursor-pointer);
  user-select: none;
  padding-inline-start: var(--ids-checkbox-padding-inline-start);
  margin-inline-end: var(--ids-checkbox-margin-inline-end);
  position: relative;
  display: inline-block;
}
.ids-checkbox label.empty::before {
  content: " ";
}
.ids-checkbox label.required .label-checkbox::after {
  position: absolute;
  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);
  font-size: var(--ids-font-size-md);
  color: var(--ids-input-required-indicator-color-text-default);
  content: "*";
  right: -10px;
  top: -3px;
}
.ids-checkbox label.no-required-indicator .label-checkbox::after, .ids-checkbox label.empty .label-checkbox::after {
  content: "";
}
.ids-checkbox .label-checkbox {
  position: initial;
  top: 1px;
}
.ids-checkbox.disabled label {
  cursor: var(--ids-cursor-default);
  opacity: var(--ids-checkbox-opacity-disabled);
}
.ids-checkbox.disabled label.required .label-checkbox::after {
  color: var(--ids-input-required-indicator-color-text-disabled);
}
.ids-checkbox.hitbox {
  padding-top: var(--ids-space-12);
  padding-bottom: var(--ids-space-12);
}
.ids-checkbox.hitbox label {
  padding-inline-start: 42px;
}
.ids-checkbox.hitbox label span.checkmark {
  margin-inline-start: 14px;
}
.ids-checkbox.hitbox .validation-message {
  margin-inline-start: 14px;
}
.ids-checkbox.horizontal {
  margin-inline-end: var(--ids-space-12);
  display: inline-block;
}
.ids-checkbox input[type=checkbox] {
  position: absolute;
  cursor: var(--ids-cursor-pointer);
  opacity: 0;
  height: 0;
  width: 0;
}
.ids-checkbox input[type=checkbox] ~ .checkmark {
  position: absolute;
  border: var(--ids-checkbox-border);
  border-radius: var(--ids-checkbox-border-radius);
  height: 14px;
  width: 14px;
  left: 0;
  top: 3px;
}
.ids-checkbox input[type=checkbox].error ~ .checkmark {
  border-color: var(--ids-checkbox-color-border-error);
}
.ids-checkbox input[type=checkbox]:checked ~ .checkmark {
  background-color: var(--ids-checkbox-color-background-selected);
  border-color: var(--ids-checkbox-color-border-selected);
}
.ids-checkbox input[type=checkbox]:checked ~ .checkmark::after {
  position: absolute;
  display: block;
  border: var(--ids-font-size-2xs) solid var(--ids-checkbox-color-border-selected-after);
  border-width: var(--ids-checkbox-border-width-selected-after);
  animation: check 0.15s;
  transform: rotate(45deg);
  content: "";
  height: 10px;
  left: 4px;
  top: 0;
  width: 4px;
}
.ids-checkbox input[type=checkbox].indeterminate ~ .checkmark {
  background-color: var(--ids-checkbox-color-background-indeterminate);
  border-color: var(--ids-checkbox-color-border-indeterminate);
}
.ids-checkbox input[type=checkbox].indeterminate ~ .checkmark::after {
  position: absolute;
  animation: checkindeterminate 0.15s;
  display: block;
  border: 1px solid var(--ids-checkbox-color-border-indeterminate-after);
  border-width: var(--ids-checkbox-border-width-indeterminate);
  content: "";
  height: 6px;
  left: 2px;
  top: 0;
  transform: none;
  width: 10px;
}
.ids-checkbox input[type=checkbox]:focus ~ .checkmark {
  border-color: var(--ids-checkbox-color-border-focus);
  box-shadow: var(--ids-checkbox-shadow-focus);
}
.ids-checkbox input[type=checkbox]:focus.error ~ .checkmark {
  border-color: var(--ids-checkbox-color-border-focus-error);
  box-shadow: var(--ids-checkbox-shadow-focus-error);
}
.ids-checkbox input[type=checkbox]:disabled ~ .checkmark {
  background-color: var(--ids-checkbox-color-background-disabled);
  border-color: var(--ids-checkbox-color-border-disabled);
  cursor: var(--ids-cursor-default);
}
.ids-checkbox input[type=checkbox]:disabled ~ .label-checkbox {
  cursor: var(--ids-cursor-default);
  color: var(--ids-checkbox-color-text-disabled);
}
.ids-checkbox input[type=checkbox]:disabled.error ~ .checkmark {
  border-color: var(--ids-checkbox-color-border-focus-error);
}
.ids-checkbox input[type=checkbox]:disabled:checked ~ .checkmark {
  background-color: var(--ids-checkbox-color-background-selected-disabled);
  border-color: var(--ids-checkbox-color-border-selected-disabled);
}
.ids-checkbox.no-animation input[type=checkbox]:checked ~ .checkmark::after {
  animation: none;
}
.ids-checkbox[color=green] input[type=checkbox] ~ .checkmark {
  background-color: var(--ids-color-green-70);
  border-color: var(--ids-color-green-70);
}
.ids-checkbox[color=green] input[type=checkbox]:disabled ~ .checkmark {
  background-color: var(--ids-checkbox-color-background-disabled);
  border-color: var(--ids-checkbox-color-border-disabled);
  cursor: var(--ids-cursor-default);
}
.ids-checkbox[color=green] input[type=checkbox]:disabled:checked ~ .checkmark {
  background-color: var(--ids-checkbox-color-background-selected-disabled);
  border-color: var(--ids-checkbox-color-border-selected-disabled);
}
.ids-checkbox[color=green] input[type=checkbox]:focus ~ .checkmark {
  border-color: var(--ids-color-green-70);
}
.ids-checkbox[color=purple] input[type=checkbox] ~ .checkmark {
  background-color: var(--ids-color-purple-70);
  border-color: var(--ids-color-purple-70);
}
.ids-checkbox[color=purple] input[type=checkbox]:disabled ~ .checkmark {
  background-color: var(--ids-checkbox-color-background-disabled);
  border-color: var(--ids-checkbox-color-border-disabled);
  cursor: var(--ids-cursor-default);
}
.ids-checkbox[color=purple] input[type=checkbox]:disabled:checked ~ .checkmark {
  background-color: var(--ids-checkbox-color-background-selected-disabled);
  border-color: var(--ids-checkbox-color-border-selected-disabled);
}
.ids-checkbox[color=purple] input[type=checkbox]:focus ~ .checkmark {
  border-color: var(--ids-color-purple-70);
}
.ids-checkbox[color=blue] input[type=checkbox] ~ .checkmark {
  background-color: var(--ids-color-blue-70);
  border-color: var(--ids-color-blue-70);
}
.ids-checkbox[color=blue] input[type=checkbox]:disabled ~ .checkmark {
  background-color: var(--ids-checkbox-color-background-disabled);
  border-color: var(--ids-checkbox-color-border-disabled);
  cursor: var(--ids-cursor-default);
}
.ids-checkbox[color=blue] input[type=checkbox]:disabled:checked ~ .checkmark {
  background-color: var(--ids-checkbox-color-background-selected-disabled);
  border-color: var(--ids-checkbox-color-border-selected-disabled);
}
.ids-checkbox[color=blue] input[type=checkbox]:focus ~ .checkmark {
  border-color: var(--ids-color-blue-70);
}
.ids-checkbox[color=orange] input[type=checkbox] ~ .checkmark {
  background-color: var(--ids-color-orange-70);
  border-color: var(--ids-color-orange-70);
}
.ids-checkbox[color=orange] input[type=checkbox]:disabled ~ .checkmark {
  background-color: var(--ids-checkbox-color-background-disabled);
  border-color: var(--ids-checkbox-color-border-disabled);
  cursor: var(--ids-cursor-default);
}
.ids-checkbox[color=orange] input[type=checkbox]:disabled:checked ~ .checkmark {
  background-color: var(--ids-checkbox-color-background-selected-disabled);
  border-color: var(--ids-checkbox-color-border-selected-disabled);
}
.ids-checkbox[color=orange] input[type=checkbox]:focus ~ .checkmark {
  border-color: var(--ids-color-orange-70);
}
.ids-checkbox[color=red] input[type=checkbox] ~ .checkmark {
  background-color: var(--ids-color-red-70);
  border-color: var(--ids-color-red-70);
}
.ids-checkbox[color=red] input[type=checkbox]:disabled ~ .checkmark {
  background-color: var(--ids-checkbox-color-background-disabled);
  border-color: var(--ids-checkbox-color-border-disabled);
  cursor: var(--ids-cursor-default);
}
.ids-checkbox[color=red] input[type=checkbox]:disabled:checked ~ .checkmark {
  background-color: var(--ids-checkbox-color-background-selected-disabled);
  border-color: var(--ids-checkbox-color-border-selected-disabled);
}
.ids-checkbox[color=red] input[type=checkbox]:focus ~ .checkmark {
  border-color: var(--ids-color-red-70);
}
.ids-checkbox .validation-message {
  margin-top: var(--ids-space-2xs);
  margin-inline-start: -1px;
}
.ids-checkbox.has-focus input[type=checkbox] ~ .checkmark {
  border-color: var(--ids-checkbox-focus-border-color);
  box-shadow: var(--ids-checkbox-focus-box-shadow);
}

:host([dir=rtl]) input[type=checkbox] ~ .checkmark {
  left: initial;
  right: 0;
}
:host([dir=rtl]) label.required .label-checkbox::after {
  right: initial;
  left: -13px;
}

:host(.multiselect-checkbox) input[type=checkbox]:not(:checked):not(:disabled) ~ .checkmark {
  background-color: var(--ids-checkbox-color-background-multiselect);
}

:host(.multiselect-checkbox.ellipsis) .ids-checkbox label {
  padding-inline-start: var(--ids-space-sm);
  overflow: hidden;
  text-overflow: ellipsis;
  width: 250px;
  max-width: 250px;
  vertical-align: top;
}
:host(.multiselect-checkbox.ellipsis) .ids-checkbox label ids-text::part(text),
:host(.multiselect-checkbox.ellipsis) .ids-checkbox label .ids-text {
  display: unset;
}

:host(.multiselect-loaded) .ids-checkbox {
  text-indent: 0;
  margin-inline-start: var(--ids-space-xs);
}
:host(.multiselect-loaded) .ids-checkbox label {
  margin-inline-end: 0;
  padding-inline-start: 12px;
}`, "",{"version":3,"sources":["webpack://./src/components/ids-checkbox/ids-checkbox.scss","webpack://./src/themes/mixins/ids-checkbox-mixin.scss","webpack://./src/themes/mixins/ids-validation-mixin.scss","webpack://./src/themes/mixins/ids-core-mixins.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;;EAAA;AAoIA;EACE;IACE,SAAA;IACA,OAAA;IACA,QAAA;IACA,QAAA;ED/HF;ECkIA;IACE,SAAA;IACA,OAAA;IACA,QAAA;IACA,UAAA;EDhIF;ECmIA;IACE,YAAA;IACA,SAAA;IACA,MAAA;IACA,UAAA;EDjIF;AACF;ACoIA;EACE;IACE,QAAA;EDlIF;ECqIA;IACE,WAAA;EDnIF;AACF;AE7BA;ECQE,mCAAA;EACA,kCAAA;EDNA,aAAA;EACA,+EAAA;EACA,gCAAA;EACA,sCAAA;AF+BF;AE7BE;EACE,oCAAA;AF+BJ;AE5BE;EACE,2CAAA;AF8BJ;AE3BE;EACE,uCAAA;AF6BJ;AE1BE;EACE,uCAAA;AF4BJ;AE1BI;EACE,iCAAA;AF4BN;AExBE;EACE,uCAAA;AF0BJ;AExBI;EACE,iCAAA;AF0BN;AEtBE;EACE,qCAAA;AFwBJ;AEtBI;EACE,8BAAA;AFwBN;AEpBE;EACE,oCAAA;AFsBJ;AEpBI;EACE,+BAAA;AFsBN;AElBE;EACE,uCAAA;AFoBJ;AElBI;EACE,gCAAA;AFoBN;AEhBE;EACE,aAAA;AFkBJ;;AA9EA;;EAEE,oBAAA;AAiFF;;AA9EA;EACE,6BAAA;AAiFF;;AA9EA;EACE,kCAAA;EACA,0CAAA;AAiFF;AA/EE;EACE,iCAAA;EACA,iBAAA;EACA,8DAAA;EACA,wDAAA;EACA,kBAAA;EACA,qBAAA;AAiFJ;AA/EI;EACE,YAAA;AAiFN;AA9EI;EACE,kBAAA;EACA,+EAAA;EACA,kCAAA;EACA,6DAAA;EACA,YAAA;EACA,YAAA;EACA,SAAA;AAgFN;AA3EM;EACE,WAAA;AA6ER;AAxEE;EACE,iBAAA;EACA,QAAA;AA0EJ;AAvEE;EACE,iCAAA;EACA,6CAAA;AAyEJ;AAvEI;EACC,8DAAA;AAyEL;AArEE;EACE,gCAAA;EACA,mCAAA;AAuEJ;AArEI;EACE,0BAAA;AAuEN;AArEM;EACE,yBAAA;AAuER;AAnEI;EACE,yBAAA;AAqEN;AAjEE;EACE,sCAAA;EACA,qBAAA;AAmEJ;AAhEE;EACE,kBAAA;EACA,iCAAA;EACA,UAAA;EACA,SAAA;EACA,QAAA;AAkEJ;AAhEI;ECjFF,kBAAA;EACA,kCAAA;EACA,gDAAA;EACA,YAAA;EACA,WAAA;EACA,OAAA;EACA,QAAA;ADoJF;AArEI;EC3EF,oDAAA;ADmJF;AApEI;EC1EF,+DAAA;EACA,uDAAA;ADiJF;AArEM;ECxEJ,kBAAA;EACA,cAAA;EACA,sFAAA;EACA,6DAAA;EACA,sBAAA;EACA,wBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,MAAA;EACA,UAAA;ADgJF;AA7EI;EC9DF,oEAAA;EACA,4DAAA;AD8IF;AA9EM;EC5DJ,kBAAA;EACA,mCAAA;EACA,cAAA;EACA,sEAAA;EACA,4DAAA;EACA,WAAA;EACA,WAAA;EACA,SAAA;EACA,MAAA;EACA,eAAA;EACA,WAAA;AD6IF;AAtFI;EC7BF,oDAAA;EACA,4CAAA;ADsHF;AAtFI;EC5BF,0DAAA;EACA,kDAAA;ADqHF;AArFM;EC3DJ,+DAAA;EACA,uDAAA;EACA,iCAAA;ADmJF;AAtFM;EChDJ,iCAAA;EACA,8CAAA;ADyIF;AAtFM;EC7DJ,0DAAA;ADsJF;AArFM;EC7DJ,wEAAA;EACA,gEAAA;ADqJF;AAlFI;EACE,eAAA;AAoFN;AC3HM;EAoBJ,2CAvBU;EAwBV,uCAxBU;ADkIZ;AC3HM;EA5CJ,+DAAA;EACA,uDAAA;EACA,iCAAA;AD0KF;AC5HM;EAtCJ,wEAAA;EACA,gEAAA;ADqKF;AC5HM;EAaJ,uCA5BU;AD8IZ;AC3IM;EAoBJ,4CAvBU;EAwBV,wCAxBU;ADkJZ;AC3IM;EA5CJ,+DAAA;EACA,uDAAA;EACA,iCAAA;AD0LF;AC5IM;EAtCJ,wEAAA;EACA,gEAAA;ADqLF;AC5IM;EAaJ,wCA5BU;AD8JZ;AC3JM;EAoBJ,0CAvBU;EAwBV,sCAxBU;ADkKZ;AC3JM;EA5CJ,+DAAA;EACA,uDAAA;EACA,iCAAA;AD0MF;AC5JM;EAtCJ,wEAAA;EACA,gEAAA;ADqMF;AC5JM;EAaJ,sCA5BU;AD8KZ;AC3KM;EAoBJ,4CAvBU;EAwBV,wCAxBU;ADkLZ;AC3KM;EA5CJ,+DAAA;EACA,uDAAA;EACA,iCAAA;AD0NF;AC5KM;EAtCJ,wEAAA;EACA,gEAAA;ADqNF;AC5KM;EAaJ,wCA5BU;AD8LZ;AC3LM;EAoBJ,yCAvBU;EAwBV,qCAxBU;ADkMZ;AC3LM;EA5CJ,+DAAA;EACA,uDAAA;EACA,iCAAA;AD0OF;AC5LM;EAtCJ,wEAAA;EACA,gEAAA;ADqOF;AC5LM;EAaJ,qCA5BU;AD8MZ;AA7JE;EACE,gCAAA;EACA,yBAAA;AA+JJ;AA3JI;EACE,oDAAA;EACA,gDAAA;AA6JN;;AAtJE;EACE,aAAA;EACA,QAAA;AAyJJ;AAtJE;EACE,cAAA;EACA,WAAA;AAwJJ;;AAlJE;EACE,kEAAA;AAqJJ;;AAhJE;EACE,yCAAA;EACA,gBAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;AAmJJ;AAjJI;;EAEE,cAAA;AAmJN;;AA7IE;EACE,cAAA;EACA,wCAAA;AAgJJ;AA9II;EACE,oBAAA;EACA,0BAAA;AAgJN","sourcesContent":["@use '../../themes/mixins/ids-checkbox-mixin' as checkbox;\n@use '../../themes/mixins/ids-validation-mixin' as valid;\n\n:host(.justify-center) .ids-checkbox .checkmark,\n:host(.justify-center) .ids-checkbox:not([color]) input[type='checkbox'] ~ .checkmark {\n  top: calc(50% - 8px);\n}\n\n:host([no-margin]) .ids-checkbox {\n  margin: var(--ids-space-none);\n}\n\n.ids-checkbox {\n  margin-bottom: var(--ids-space-xs);\n  margin-top: var(--ids-checkbox-margin-top);\n\n  label {\n    cursor: var(--ids-cursor-pointer);\n    user-select: none;\n    padding-inline-start: var(--ids-checkbox-padding-inline-start);\n    margin-inline-end: var(--ids-checkbox-margin-inline-end);\n    position: relative;\n    display: inline-block;\n\n    &.empty::before {\n      content: '\\00a0';\n    }\n\n    &.required .label-checkbox::after {\n      position: absolute;\n      font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);\n      font-size: var(--ids-font-size-md);\n      color: var(--ids-input-required-indicator-color-text-default);\n      content: '*';\n      right: -10px;\n      top: -3px;\n    }\n\n    &.no-required-indicator,\n    &.empty {\n      .label-checkbox::after {\n        content: '';\n      }\n    }\n  }\n\n  .label-checkbox {\n    position: initial;\n    top: 1px;\n  }\n\n  &.disabled label {\n    cursor: var(--ids-cursor-default);\n    opacity: var(--ids-checkbox-opacity-disabled);\n\n    &.required .label-checkbox::after {\n     color: var(--ids-input-required-indicator-color-text-disabled);\n    }\n  }\n\n  &.hitbox {\n    padding-top: var(--ids-space-12);\n    padding-bottom: var(--ids-space-12);\n\n    label {\n      padding-inline-start: 42px;\n\n      span.checkmark {\n        margin-inline-start: 14px;\n      }\n    }\n\n    .validation-message {\n      margin-inline-start: 14px;\n    }\n  }\n\n  &.horizontal {\n    margin-inline-end: var(--ids-space-12);\n    display: inline-block;\n  }\n\n  input[type='checkbox'] {\n    position: absolute;\n    cursor: var(--ids-cursor-pointer);\n    opacity: 0;\n    height: 0;\n    width: 0;\n\n    ~ .checkmark {\n      @include checkbox.checkbox-unchecked();\n    }\n\n    &.error ~ .checkmark {\n      @include checkbox.checkbox-unchecked-error();\n    }\n\n    &:checked ~ .checkmark {\n      @include checkbox.checkbox-checked();\n\n      &::after {\n        @include checkbox.checkbox-checked-after();\n      }\n    }\n\n    &.indeterminate ~ .checkmark {\n      @include checkbox.checkbox-indeterminate();\n\n      &::after {\n        @include checkbox.checkbox-indeterminate-after();\n      }\n    }\n\n    &:focus ~ .checkmark {\n      @include checkbox.checkbox-focus();\n    }\n\n    &:focus.error ~ .checkmark {\n      @include checkbox.checkbox-focus-error();\n    }\n\n    &:disabled {\n      ~ .checkmark {\n        @include checkbox.checkbox-disabled-unchecked();\n      }\n\n      ~ .label-checkbox {\n        @include checkbox.checkbox-disabled-text();\n      }\n\n      &.error ~ .checkmark {\n        @include checkbox.checkbox-disabled-unchecked-error();\n      }\n\n      &:checked ~ .checkmark {\n        @include checkbox.checkbox-disabled-checked();\n      }\n    }\n  }\n\n  &.no-animation {\n    input[type='checkbox']:checked ~ .checkmark::after {\n      animation: none;\n    }\n  }\n\n  // Colored Checkboxes\n  @include checkbox.checkbox-colored();\n\n  .validation-message {\n    margin-top: var(--ids-space-2xs);\n    margin-inline-start: -1px;\n  }\n\n  &.has-focus {\n    input[type='checkbox'] ~ .checkmark {\n      border-color: var(--ids-checkbox-focus-border-color);\n      box-shadow: var(--ids-checkbox-focus-box-shadow);\n    }\n  }\n}\n\n// Negate some rules for RTL\n:host([dir='rtl']) {\n  input[type='checkbox'] ~ .checkmark {\n    left: initial;\n    right: 0;\n  }\n\n  label.required .label-checkbox::after {\n    right: initial;\n    left: -13px;\n  }\n}\n\n// Multiselect checkbox\n:host(.multiselect-checkbox) {\n  input[type='checkbox']:not(:checked):not(:disabled) ~ .checkmark {\n    background-color: var(--ids-checkbox-color-background-multiselect);\n  }\n}\n\n:host(.multiselect-checkbox.ellipsis) {\n  .ids-checkbox label {\n    padding-inline-start: var(--ids-space-sm);\n    overflow: hidden;\n    text-overflow: ellipsis;\n    width: 250px;\n    max-width: 250px;\n    vertical-align: top;\n\n    ids-text::part(text),\n    .ids-text {\n      display: unset;\n    }\n  }\n}\n\n:host(.multiselect-loaded) {\n  .ids-checkbox {\n    text-indent: 0;\n    margin-inline-start: var(--ids-space-xs);\n\n    label {\n      margin-inline-end: 0;\n      padding-inline-start: 12px;\n    }\n  }\n}\n","/**\n * Checkbox Mixins.\n */\n@use 'sass:list';\n@use '../../themes/mixins/ids-core-mixins' as mixins;\n\n// Unchecked\n@mixin checkbox-unchecked() {\n  position: absolute;\n  border: var(--ids-checkbox-border);\n  border-radius: var(--ids-checkbox-border-radius);\n  height: 14px;\n  width: 14px;\n  left: 0;\n  top: 3px;\n}\n\n@mixin checkbox-unchecked-error {\n  border-color: var(--ids-checkbox-color-border-error);\n}\n\n// Checked\n@mixin checkbox-checked() {\n  background-color: var(--ids-checkbox-color-background-selected);\n  border-color: var(--ids-checkbox-color-border-selected);\n}\n\n@mixin checkbox-checked-after {\n  position: absolute;\n  display: block;\n  border: var(--ids-font-size-2xs) solid var(--ids-checkbox-color-border-selected-after);\n  border-width: var(--ids-checkbox-border-width-selected-after);\n  animation: check 0.15s;\n  transform: rotate(45deg);\n  content: '';\n  height: 10px;\n  left: 4px;\n  top: 0;\n  width: 4px;\n}\n\n// Indeterminate\n@mixin checkbox-indeterminate() {\n  background-color: var(--ids-checkbox-color-background-indeterminate);\n  border-color: var(--ids-checkbox-color-border-indeterminate);\n}\n\n@mixin checkbox-indeterminate-after {\n  position: absolute;\n  animation: checkindeterminate 0.15s;\n  display: block;\n  border: 1px solid var(--ids-checkbox-color-border-indeterminate-after);\n  border-width: var(--ids-checkbox-border-width-indeterminate);\n  content: '';\n  height: 6px;\n  left: 2px;\n  top: 0;\n  transform: none;\n  width: 10px;\n}\n\n// Disabled\n@mixin checkbox-disabled-unchecked {\n  background-color: var(--ids-checkbox-color-background-disabled);\n  border-color: var(--ids-checkbox-color-border-disabled);\n  cursor: var(--ids-cursor-default);\n}\n\n@mixin checkbox-disabled-unchecked-error {\n  border-color: var(--ids-checkbox-color-border-focus-error);\n}\n\n@mixin checkbox-disabled-checked() {\n  background-color: var(--ids-checkbox-color-background-selected-disabled);\n  border-color: var(--ids-checkbox-color-border-selected-disabled);\n}\n\n@mixin checkbox-disabled-text {\n  cursor: var(--ids-cursor-default);\n  color: var(--ids-checkbox-color-text-disabled);\n}\n\n// Focus\n@mixin checkbox-focus {\n  border-color: var(--ids-checkbox-color-border-focus);\n  box-shadow: var(--ids-checkbox-shadow-focus);\n}\n\n@mixin checkbox-focus-error {\n  border-color: var(--ids-checkbox-color-border-focus-error);\n  box-shadow: var(--ids-checkbox-shadow-focus-error);\n}\n\n// Colored\n$color-names: 'green' 'purple' 'blue' 'orange' 'red';\n$color-vars: --ids-color-green-70 --ids-color-purple-70 --ids-color-blue-70 --ids-color-orange-70 --ids-color-red-70;\n\n@mixin checkbox-colored() {\n  @each $name in $color-names {\n    $i: list.index($color-names, $name);\n    $color: var(#{list.nth($color-vars, $i)});\n\n    &[color='#{$name}'] input[type='checkbox'] {\n      ~ .checkmark {\n        @include checkbox-colored-box($color);\n      }\n\n      &:disabled ~ .checkmark {\n        @include checkbox-disabled-unchecked();\n      }\n\n      &:disabled:checked ~ .checkmark {\n        @include checkbox-disabled-checked();\n      }\n\n      &:focus ~ .checkmark {\n        @include checkbox-colored-box-focus($color);\n      }\n    }\n  }\n}\n\n@mixin checkbox-colored-box($color) {\n  background-color: $color;\n  border-color: $color;\n}\n\n@mixin checkbox-colored-box-focus($color) {\n  border-color: $color;\n}\n\n// Animations\n@keyframes check {\n  0% {\n    height: 0;\n    left: 0;\n    top: 8px;\n    width: 0;\n  }\n\n  50% {\n    height: 0;\n    left: 0;\n    top: 8px;\n    width: 4px;\n  }\n\n  100% {\n    height: 10px;\n    left: 4px;\n    top: 0;\n    width: 4px;\n  }\n}\n\n@keyframes checkindeterminate {\n  0% {\n    width: 0;\n  }\n\n  100% {\n    width: 10px;\n  }\n}\n","@use '../../themes/mixins/ids-core-mixins' as mixins;\n\n.validation-message {\n  @include mixins.antialiased();\n\n  display: flex;\n  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);\n  margin-top: var(--ids-space-2xs);\n  max-width: var(--ids-input-width-full);\n\n  &.has-custom-icon {\n    color: var(--ids-icon-color-default);\n  }\n\n  &.disabled {\n    color: var(--ids-input-color-text-disabled);\n  }\n\n  .ids-icon {\n    margin-inline-end: var(--ids-space-2xs);\n  }\n\n  &.alert {\n    color: var(--ids-color-caution-default);\n\n    &.disabled {\n      color: var(--ids-color-yellow-30);\n    }\n  }\n\n  &.warning {\n    color: var(--ids-color-warning-default);\n\n    &.disabled {\n      color: var(--ids-color-orange-30);\n    }\n  }\n\n  &.error {\n    color: var(--ids-color-error-default);\n\n    &.disabled {\n      color: var(--ids-color-red-30);\n    }\n  }\n\n  &.info {\n    color: var(--ids-color-info-default);\n\n    &.disabled {\n      color: var(--ids-color-blue-30);\n    }\n  }\n\n  &.success {\n    color: var(--ids-color-success-default);\n\n    &.disabled {\n      color: var(--ids-color-green-30);\n    }\n  }\n\n  &[hidden] {\n    display: none;\n  }\n}\n","// Breakpoints - this cant be tokens\n$breakpoint-xxl: 1440px;\n$breakpoint-xl: 1280px;\n$breakpoint-lg: 1024px;\n$breakpoint-md: 840px;\n$breakpoint-sm: 600px;\n$breakpoint-xs: 320px;\n\n// Sets Text Antialiasing\n@mixin antialiased {\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n// vendor prefixed transitions for regular attributes (non-vendor prefixed)\n@mixin transition($transitions-list...) {\n  @each $prefix in $prefixes {\n    #{$prefix}transition: $transitions-list;\n  }\n}\n\n// make the text invisible visually but readable by screen readers\n@mixin audible() {\n  clip: rect(0, 0, 0, 0);\n  height: 0;\n  line-height: 0;\n  min-height: 0;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
